import { render } from "./ActivityTypesView.vue?vue&type=template&id=3e37b8ac"
import script from "./ActivityTypesView.vue?vue&type=script&lang=js"
export * from "./ActivityTypesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__